import * as React from 'react';
import { Route, Routes, useParams } from 'react-router-dom'
import { timetableRoutes } from './routes';
import { timetablePath } from './index';
import { toRelativeRoute, wrapRoutesWithRouter } from '../shared/utils/routerPaths';

const wrappedTimetableRoutes = wrapRoutesWithRouter(timetableRoutes)
import { TimetableLayout } from './TimetableLayout';
import { AppLayoutDahboardWithNav } from '../shared/layouts';
import { ErrorBoundary } from '../shared/components/ErrorBoundary';
import { ErrorFallback } from '../shared/components/ErrorFallback';
import { TaskProvider } from '../shared/context/TaskContext';
import { PermissionGuard } from '@/modules/shared/components/NoPermission'
import { moduleAccess } from '@/modules/shared/permissions'

const TimetableModuleImpl: React.FC = () => {
  const { companyId } = useParams<{ companyId: string }>();

  return (
    <ErrorBoundary
      fallback={(e) => <ErrorFallback error={e.error} onRetry={e.reset} />}
    >
        <TaskProvider>
              <AppLayoutDahboardWithNav>
              <ErrorBoundary
                fallback={(e) => (
                  <ErrorFallback error={e.error} onRetry={e.reset} />
                )}
              >
                <PermissionGuard companyId={companyId} {...moduleAccess.timetable}>
                <Routes>
                  {wrappedTimetableRoutes.map((route) => (
                        <Route
                        key={route.path}
                        path={`${toRelativeRoute(route.path, timetablePath)}/*`}
                        element={
                          <TimetableLayout
                            companyId={companyId!}
                            viewControlBar={route.viewControlBar}
                            heightScreen={route.heightScreen}
                          >
                            <route.Component />
                          </TimetableLayout>
                        }
                      />
                      ))}

                  {/* fallback */}
                  <Route
                    path="*"
                    element={
                      <TimetableLayout companyId={companyId!}>
                        <div>Select</div>
                      </TimetableLayout>
                    }
                  />
                </Routes>
                </PermissionGuard>
              </ErrorBoundary>
            </AppLayoutDahboardWithNav>
        </TaskProvider>
    </ErrorBoundary>
  );
};

export const TimetableModule = TimetableModuleImpl
